import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { gradient, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight, fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
export { signupBtn } from "@components/login-wrapper/LoginWrapper.styles";

export const container: CSSProperties = {
  padding: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  flex: 1,
};

export const paper: CSSProperties = {
  background: greys.white,
  borderRadius: 10,
  width: "360px",
  padding: 60,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  position: "relative",
};

export const loadingBar: CSSProperties = {
  backgroundColor: "transparent",
  position: "absolute",
  bottom: 0,
  width: "100%",
};

export const content = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    flexShrink: 0,
  } as CSSProperties,
  hero: {
    height: 95,
    width: 95,
    background: gradient,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    flexShrink: 0,
  } as CSSProperties,
  logo: {
    width: 60,
  } as CSSProperties,
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: spacing.std,
    paddingRight: spacing.sm,
    paddingBottom: spacing.sm,
    paddingLeft: spacing.sm,
  } as CSSProperties,
  header: {
    textAlign: "center",
  } as CSSProperties,
  button: {
    padding: "10px 0 5px 0",
  } as CSSProperties,
  agreement: {
    fontFamily: fontFamilySans,
    color: greys.slate,
    fontSize: size.sm,
    fontWeight: weight.std,
    marginTop: spacing.sm,
    textAlign: "center",
  } as CSSProperties,
  link: {
    color: greys.dark,
    borderBottomWidth: 0,
  } as CSSProperties,
};
